import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import {
  ALL_TAB_ID,
  AssessmentProgressNotificationResult,
  NOTIFICATION_ASSESSMENT_PROGRESS,
  NotificationTypes,
  SaiftyNotification,
  Tab,
} from '@/config'

export const NOTIFICATION_TYPES_TO_BE_HIDDEN = [NOTIFICATION_ASSESSMENT_PROGRESS]

const notifications = ref<SaiftyNotification[]>([])

const notificationsNotRead = computed(() => {
  return notifications.value.filter((notification) => !notification.status && isVisibleNotification(notification))
})

const technicalNotificationsNotRead = computed(() => {
  return notifications.value.filter((notification) => !notification.status && !isVisibleNotification(notification))
})

const assessmentProgressNotifications = computed(() => {
  return notifications.value.filter((notification) => notification.messageType === NOTIFICATION_ASSESSMENT_PROGRESS)
})

const highestProgressByAssessment = computed(() => {
  const map = new Map<string, AssessmentProgressNotificationResult>()

  for (const n of assessmentProgressNotifications.value) {
    if (
      n.messageType !== NOTIFICATION_ASSESSMENT_PROGRESS ||
      typeof n.data?.dataAssetId !== 'string' ||
      typeof n.data?.message?.Progress !== 'number' ||
      typeof n.data?.message?.Total !== 'number'
    ) {
      continue
    }

    const id = n.data.dataAssetId
    const progress = n.data.message.Progress
    const total = n.data.message.Total

    const existing = map.get(id)

    if (!existing || progress > existing.progress) {
      map.set(id, { progress, total })
    }
  }

  return map
})

export function isVisibleNotification(notification: SaiftyNotification): boolean {
  return !NOTIFICATION_TYPES_TO_BE_HIDDEN.includes(notification.messageType)
}

export default function useNotifications() {
  const { t } = useI18n()
  const currentNotificationTabSelected = ref<string>(ALL_TAB_ID)
  const notificationsTabsSections = <Tab[]>[
    { label: t('All'), id: ALL_TAB_ID },
    // { label: t('Extractions'), id: NotificationTypes.Extraction.toString() },
    // { label: t('Passports'), id: NotificationTypes.Passport.toString() },
    // { label: t('Requests'), id: NotificationTypes.Request.toString() },
  ]
  const tenMinutesAgo = Date.now() - 1000 * 60 * 10

  const notificationsFiltered = computed(() => {
    if (currentNotificationTabSelected.value) {
      if (currentNotificationTabSelected.value === ALL_TAB_ID) {
        return notifications.value
      } else {
        return notifications.value.filter(
          (notification) =>
            getNotificationTypeFromNotification(notification) &&
            getNotificationTypeFromNotification(notification) === currentNotificationTabSelected.value
        )
      }
    } else {
      return notifications.value
    }
  })

  const notificationsNotReadFiltered = computed(() => {
    if (currentNotificationTabSelected.value) {
      if (currentNotificationTabSelected.value === ALL_TAB_ID) {
        return notificationsNotRead.value
      } else {
        return notificationsNotRead.value.filter(
          (notification) =>
            getNotificationTypeFromNotification(notification) &&
            getNotificationTypeFromNotification(notification) === currentNotificationTabSelected.value
        )
      }
    } else {
      return notificationsNotRead.value
    }
  })

  const notificationsFromTenMinutesAgo = computed(() => {
    return notifications.value.filter(
      (notification) =>
        (notification.timestamp > tenMinutesAgo || !notification.status) && isVisibleNotification(notification)
    ) // When there is no status, it means that the notification is new
  })

  function onTabClicked(tab: string) {
    currentNotificationTabSelected.value = tab
  }

  // TODO: Improve the logic
  function getNotificationTypeFromNotification(notification: SaiftyNotification) {
    if (notification.messageType.includes('EXTRACTION')) return NotificationTypes.Extraction
    else if (notification.messageType.includes('PASSPORT')) return NotificationTypes.Passport
    else if (notification.messageType.includes('REQUEST')) return NotificationTypes.Request
    else ALL_TAB_ID
  }

  function getLatestAssessmentProgress(assessmentId: string) {
    return highestProgressByAssessment.value.get(assessmentId)
  }

  return {
    notifications,
    notificationsNotRead,
    notificationsFiltered,
    notificationsNotReadFiltered,
    notificationsTabsSections,
    currentNotificationTabSelected,
    notificationsFromTenMinutesAgo,
    assessmentProgressNotifications,
    technicalNotificationsNotRead,
    highestProgressByAssessment,
    onTabClicked,
    getLatestAssessmentProgress,
  }
}
